<template>
  <ul
    id="navs"
    class="navs-circle active"
    data-open="-"
    data-close="+"
    @click="circleMenu"
    :style="{
      'background-color': customization.mainColor,
      color: customization.iconColor,
    }"
  >
    <li :style="{ 'background-color': customization.mainColor }">
      <a href="garage" :style="{ color: customization.iconColor }">
        <span class="dbc-icon dbc-icon-solid_car"></span>
      </a>
    </li>
    <li :style="{ 'background-color': customization.mainColor }">
      <a href="recommendfriend" :style="{ color: customization.iconColor }">
        <span class="dbc-icon dbc-icon-users-three"></span>
        <span class="badge" v-if="referralsCount">{{referralsCount}}</span>
      </a>
    </li>
    <li :style="{ 'background-color': customization.mainColor }">
      <a href="contact" :style="{ color: customization.iconColor }">
        <span class="dbc-icon dbc-icon-card-account-phone"></span>
      </a>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'circle-menu',
  props: {
    referralsCount: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    ...mapState({
      customization: (state) => state.common.customization
    })
  },
  methods: {
    circleMenu () {
      this.switcher = !this.switcher
      var elem = document.getElementById('navs')
      if (!elem) {
        console.error('circle navigation element not found')
        return
      }
      this.switcher ? elem.classList.remove('active') : elem.classList.add('active')
    }
  }
}
</script>

<style scoped>
#navs {
  position: absolute;
  right: 5px;
  bottom: 5px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: center;
  color: #000;
  cursor: pointer;
  z-index: 999999;
  font-size: 30px;
  font-weight: 300;
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  transition-duration: 0.3s;
}

#navs > li,
#navs:after {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  /* background-color: #f9f301; */
}

#navs > li {
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: 0.3s;
}

#navs:after {
  content: attr(data-close);
  z-index: 1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
}

#navs.active:after {
  content: attr(data-open);
}

#navs a {
  width: 40px;
  height: 40px;
  display: inline-block;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  text-decoration: none;
  color: #fff;
  font-size: 0.8em;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

#navs a > .badge{
    position: absolute;
    display: inline-block;
    min-width: 18px;
    background-color: rgb(255, 61, 61);
    padding: 2px;
    line-height: 1;
    border-radius: 15px;
    font-size: 14px;
    top: -4px;
    right: -4px;
}

#navs a span {
  margin: 0;
  padding: 0;
}

#navs a img {
  display: block;
  width: 50%;
  text-align: center;
  margin: auto;
  padding: 10px 0 0 0;
}

.navs-circle {
  border-radius: 50%;
}

.navs-circle span {
  font-size: 22px;
  display: none;
}

.navs-circle.active span {
  display: block;
}

.navs-circle > li {
  visibility: hidden;
  opacity: 0;
}

#navs.navs-circle.active > li:nth-child(1) {
  transition-delay: 250ms;
  top: -80px;
}

#navs.navs-circle.active > li:nth-child(2) {
  transition-delay: 200ms;
  left: -49.541px;
  top: -56.0634px;
}

#navs.navs-circle.active > li:nth-child(3) {
  transition-delay: 150ms;
  left: -76.2671px;
  top: -5.541px;
}

.navs-circle.active > li {
  visibility: visible;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// circle-menu.component.vue?0c16ede5